import React from "react";

function GenericNotFound(){
  return(
    <div>
      <h1>404</h1>
      <p>Path not found</p>
    </div>
  );
}

export default GenericNotFound;